import request from '@/util/request';
import qs from 'qs';

export const getList = (params, options) =>
  request.get('/api/park/user/page', Object.assign({}, options, { params }));

export const getDetail = (params, options) =>
  request.get('/api/park/user/detail', Object.assign({}, options, { params }));

export const remove = (params, options) =>
  request.post('/api/park/user/remove', qs.stringify(params), options);

export const add = (params, options) => request.post('/api/park/user/save', params, options);

export const update = (params, options) => request.post('/api/park/user/update', params, options);
